import {
  CustomerContact,
  CustomerSalutation,
  CustomerTitle,
  DealerConsent,
  DmsId,
  NationalIdDocumentType,
} from './customer-information.model';
import { CustomerVehicle } from './customer-vehicle.model';

/**
 * View model, which is filled by Retail CRM customers.
 * The model is used to display customer information within the customer profile page.
 * It is NOT used to display search results.
 */
export interface Customer {
  accountNumber: string;
  gcid?: string;
  bmwMiniId?: string;
  dmsIds?: DmsId[];
  firstName?: string;
  middleName?: string;
  lastName?: string;
  suffix?: string;
  correspondenceLanguage?: string;
  salutation?: CustomerSalutation;
  title?: CustomerTitle;
  businessContact: CustomerContact;
  privateContact: CustomerContact;
  vehicles?: CustomerVehicle[];
  inSyncWithDirectSales?: boolean;
  dealerConsent?: DealerConsent;
  taxNumber?: string;
  taxNumberCountry?: string;
  nationalId1?: string;
  nationalId1DocumentType?: NationalIdDocumentType;
}

export const makeBlankCustomer = (): Customer => ({
  accountNumber: '',
  businessContact: {},
  privateContact: {},
});
